import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import signImage from './images/sign.png';
import trackImage from './images/track.png';
import './Apply.css';

const Apply = () => {
  const [activeTab, setActiveTab] = useState('whitelist');
  const [whitelistForm, setWhitelistForm] = useState({
    qqNumber: '',
    groupNickname: '',
    gameId: '',
    noGrief: '',
    blacklistHistory: ''
  });
  const [applications, setApplications] = useState([]);
  const [opForm, setOpForm] = useState({
    qqName: '',
    qqNumber: '',
    gameId: '',
    permission: '',
    worldedit1: '',
    worldedit2: '',
    worldedit3: '',
    worldedit4: '',
      worldedit5: '',
    worldedit6: [],
    mtr2: [],
    mtr3: '',
    mtr4: '',
    curveMethod: '',
    specialSkill: '',
    guarantee: '',
    previousServer: '',
    blacklistHistory: '',
    selfIntro: '',
    buildPosition: ''
  });
  const [mtrAnswer, setMtrAnswer] = useState({ speed: '', acceleration: '', depotSpeed: '', platform6b: '', platform4a: '' });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { user, loading } = useContext(AuthContext);

  useEffect(() => {
    if (user) {
      fetchApplications();
    }
  }, [user]);

  const fetchApplications = async () => {
    try {
      const res = await axios.get('/apply/my-applications');
      setApplications(res.data);
    } catch (err) {
      console.error('获取申请记录失败:', err);
    }
  };

  const getStatusText = (status) => {
    const statusMap = {
      pending: '待审核',
      approved: '已通过',
      builder1: '已通过(Builder1)',
      builder2: '已通过(Builder2)',
      rejected: '已拒绝'
    };
    return statusMap[status] || '未知';
  };

  const getStatusClass = (status) => {
    const classMap = {
      pending: 'status-pending',
      approved: 'status-approved',
      builder1: 'status-builder1',
      builder2: 'status-builder2',
      rejected: 'status-rejected'
    };
    return classMap[status] || 'status-pending';
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('zh-CN');
  };

  if (loading) return <div className="loading">加载中...</div>;
  if (!user) return <Navigate to="/account" />;

  const handleWhitelistSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      Object.keys(whitelistForm).forEach(key => {
        data.append(key, whitelistForm[key]);
      });
      if (selectedFiles.length > 0) {
        selectedFiles.forEach(file => {
          data.append('bilibiliScreenshot', file);
        });
      }

      await axios.post('/apply/whitelist', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      alert('白名单申请已提交！');
      setWhitelistForm({
        qqNumber: '',
        groupNickname: '',
        gameId: '',
        noGrief: '',
        blacklistHistory: ''
      });
      setSelectedFiles([]);
    } catch (err) {
      console.error('提交失败:', err);
      alert('提交失败，请重试');
    }
  };

  const handleOpSubmit = async (e) => {
    e.preventDefault();
    try {
      const mtrAnswerStr = `${mtrAnswer.speed},${mtrAnswer.acceleration},${mtrAnswer.depotSpeed},${mtrAnswer.platform6b},${mtrAnswer.platform4a}`;

      await axios.post('/apply/op', {
        ...opForm,
        mtrAnswer: mtrAnswerStr
      });
      alert('OP申请已提交！');
    } catch (err) {
      console.error('提交失败:', err);
      alert('提交失败，请重试');
    }
  };

  const handleFileChange = (e) => {
    setSelectedFiles([...e.target.files]);
  };

  const handleBuildingImagesChange = (e) => {
    // 处理建筑作品图片上传
    console.log('建筑图片上传:', e.target.files);
  };

  return (
    <div className="apply">
      <h1>申请</h1>

      <div className="tabs">
        <button
          className={activeTab === 'whitelist' ? 'active' : ''}
          onClick={() => setActiveTab('whitelist')}
        >
          白名单申请
        </button>
        <button
          className={activeTab === 'op' ? 'active' : ''}
          onClick={() => setActiveTab('op')}
        >
          OP申请
        </button>
        <button
          className={activeTab === 'history' ? 'active' : ''}
          onClick={() => {
            setActiveTab('history');
            fetchApplications();
          }}
        >
          申请记录
        </button>
      </div>

      {activeTab === 'whitelist' && (
        <form onSubmit={handleWhitelistSubmit} className="apply-form">
          <input
            type="text"
            placeholder="你的QQ号"
            value={whitelistForm.qqNumber}
            onChange={(e) => setWhitelistForm({ ...whitelistForm, qqNumber: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="你的群昵称"
            value={whitelistForm.groupNickname}
            onChange={(e) => setWhitelistForm({ ...whitelistForm, groupNickname: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="你的游戏ID"
            value={whitelistForm.gameId}
            onChange={(e) => setWhitelistForm({ ...whitelistForm, gameId: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="你能否做到不破坏服务器"
            value={whitelistForm.noGrief}
            onChange={(e) => setWhitelistForm({ ...whitelistForm, noGrief: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="你有进过其他服务器的黑名单吗？如有，请说明服务器名称、封禁原因；如无，请填无"
            value={whitelistForm.blacklistHistory}
            onChange={(e) => setWhitelistForm({ ...whitelistForm, blacklistHistory: e.target.value })}
            required
          />
          <input
            type="file"
            accept="image/*"
            multiple
            onChange={handleFileChange}
            required
          />
          <p className="form-note">请上传B站一键三连截图（B站名：龙腾铁路服务器）</p>
          <button type="submit" className="btn-primary">提交申请</button>
        </form>
      )}

      {activeTab === 'op' && (
        <form onSubmit={handleOpSubmit} className="apply-form">
          <div className="form-section">
            <label className="question-label">您的qq名</label>
            <input
              type="text"
              placeholder="请输入"
              value={opForm.qqName}
              onChange={(e) => setOpForm({ ...opForm, qqName: e.target.value })}
              required
            />
          </div>

          <div className="form-section">
            <label className="question-label">您的qq号</label>
            <input
              type="text"
              placeholder="请输入"
              value={opForm.qqNumber}
              onChange={(e) => setOpForm({ ...opForm, qqNumber: e.target.value })}
              required
            />
          </div>

          <div className="form-section">
            <label className="question-label">您的游戏id</label>
            <input
              type="text"
              placeholder="请输入"
              value={opForm.gameId}
              onChange={(e) => setOpForm({ ...opForm, gameId: e.target.value })}
              required
            />
          </div>

          <div className="form-section">
            <h3>创世神考察(5分)</h3>
            <div className="question-item">
              <label>创世神模组中，如何站着不动生成一道对角分别为(0,0,0)与(6,6,0)的圆石墙</label>
              <input
                type="text"
                placeholder="请输入答案"
                value={opForm.worldedit1}
                onChange={(e) => setOpForm({ ...opForm, worldedit1: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="form-section">
            <h3>创世神考察(5分)</h3>
            <div className="question-item">
              <label>创世神模组中，如何站着不动将选区中方块复制到相邻位置</label>
              <input
                type="text"
                placeholder="请输入答案"
                value={opForm.worldedit2}
                onChange={(e) => setOpForm({ ...opForm, worldedit2: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="form-section">
            <h3>创世神考察(5分)</h3>
            <div className="question-item">
              <label>创世神模组中，如何将选区中方向朝南的石英楼梯替换为正常橡树树叶</label>
              <input
                type="text"
                placeholder="请输入答案"
                value={opForm.worldedit3}
                onChange={(e) => setOpForm({ ...opForm, worldedit3: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="form-section">
            <h3>创世神考察(5分)</h3>
            <div className="question-item">
              <label>创世神模组中，如何站着不动将选区中朝北的建筑改为朝南的建筑(位置可变)</label>
              <input
                type="text"
                placeholder="请输入答案"
                value={opForm.worldedit4}
                onChange={(e) => setOpForm({ ...opForm, worldedit4: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="form-section">
            <h3>创世神考察(5分)</h3>
            <div className="question-item">
              <label>其他玩家不小心用//set 0破坏了地形，此时你需用什么指令修复</label>
              <select
                value={opForm.worldedit5}
                onChange={(e) => setOpForm({ ...opForm, worldedit5: e.target.value })}
                required
                className="form-select"
              >
                <option value="">请选择</option>
                <option value="//undo">//undo</option>
                <option value="//redo">//redo</option>
                <option value="//regen">//regen</option>
                <option value="//fix">//fix</option>
              </select>
            </div>
          </div>

          <div className="form-section">
            <h3>[多选]创世神考察(5分)</h3>
            <div className="question-item">
              <label>以下哪些方块在rotate旋转后会出现方向错误</label>
              <div className="checkbox-group">
                <label><input type="checkbox" value="黄色偏移直线道路" checked={opForm.worldedit6.includes('黄色偏移直线道路')} onChange={(e) => {
                  const values = [...opForm.worldedit6];
                  if (e.target.checked) {
                    values.push(e.target.value);
                  } else {
                    values.splice(values.indexOf(e.target.value), 1);
                  }
                  setOpForm({ ...opForm, worldedit6: values });
                }} /> 黄色偏移直线道路</label>
                <label><input type="checkbox" value="轨道节点" checked={opForm.worldedit6.includes('轨道节点')} onChange={(e) => {
                  const values = [...opForm.worldedit6];
                  if (e.target.checked) {
                    values.push(e.target.value);
                  } else {
                    values.splice(values.indexOf(e.target.value), 1);
                  }
                  setOpForm({ ...opForm, worldedit6: values });
                }} /> 轨道节点</label>
                <label><input type="checkbox" value="天花板（有灯）" checked={opForm.worldedit6.includes('天花板（有灯）')} onChange={(e) => {
                  const values = [...opForm.worldedit6];
                  if (e.target.checked) {
                    values.push(e.target.value);
                  } else {
                    values.splice(values.indexOf(e.target.value), 1);
                  }
                  setOpForm({ ...opForm, worldedit6: values });
                }} /> 天花板（有灯）</label>
                <label><input type="checkbox" value="石英楼梯" checked={opForm.worldedit6.includes('石英楼梯')} onChange={(e) => {
                  const values = [...opForm.worldedit6];
                  if (e.target.checked) {
                    values.push(e.target.value);
                  } else {
                    values.splice(values.indexOf(e.target.value), 1);
                  }
                  setOpForm({ ...opForm, worldedit6: values });
                }} /> 石英楼梯</label>
                <label><input type="checkbox" value="墙上的白色双条形灯管" checked={opForm.worldedit6.includes('墙上的白色双条形灯管')} onChange={(e) => {
                  const values = [...opForm.worldedit6];
                  if (e.target.checked) {
                    values.push(e.target.value);
                  } else {
                    values.splice(values.indexOf(e.target.value), 1);
                  }
                  setOpForm({ ...opForm, worldedit6: values });
                }} /> 墙上的白色双条形灯管</label>
                <label><input type="checkbox" value="隧道#2" checked={opForm.worldedit6.includes('隧道#2')} onChange={(e) => {
                  const values = [...opForm.worldedit6];
                  if (e.target.checked) {
                    values.push(e.target.value);
                  } else {
                    values.splice(values.indexOf(e.target.value), 1);
                  }
                  setOpForm({ ...opForm, worldedit6: values });
                }} /> 隧道#2</label>
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3>[多选]MTR考察(5分)</h3>
            <div className="question-item">
              <label>刷新线路时提示"找不到路径"可能因为？</label>
              <div className="checkbox-group">
                <label><input type="checkbox" value="方向轨道接反" checked={opForm.mtr2.includes('方向轨道接反')} onChange={(e) => {
                  const values = [...opForm.mtr2];
                  if (e.target.checked) {
                    values.push(e.target.value);
                  } else {
                    values.splice(values.indexOf(e.target.value), 1);
                  }
                  setOpForm({ ...opForm, mtr2: values });
                }} /> 方向轨道接反</label>
                <label><input type="checkbox" value="发车间隔为0.0/小时" checked={opForm.mtr2.includes('发车间隔为0.0/小时')} onChange={(e) => {
                  const values = [...opForm.mtr2];
                  if (e.target.checked) {
                    values.push(e.target.value);
                  } else {
                    values.splice(values.indexOf(e.target.value), 1);
                  }
                  setOpForm({ ...opForm, mtr2: values });
                }} /> 发车间隔为0.0/小时</label>
                <label><input type="checkbox" value="未添加下行线路" checked={opForm.mtr2.includes('未添加下行线路')} onChange={(e) => {
                  const values = [...opForm.mtr2];
                  if (e.target.checked) {
                    values.push(e.target.value);
                  } else {
                    values.splice(values.indexOf(e.target.value), 1);
                  }
                  setOpForm({ ...opForm, mtr2: values });
                }} /> 未添加下行线路</label>
                <label><input type="checkbox" value="线路选错站台" checked={opForm.mtr2.includes('线路选错站台')} onChange={(e) => {
                  const values = [...opForm.mtr2];
                  if (e.target.checked) {
                    values.push(e.target.value);
                  } else {
                    values.splice(values.indexOf(e.target.value), 1);
                  }
                  setOpForm({ ...opForm, mtr2: values });
                }} /> 线路选错站台</label>
                <label><input type="checkbox" value="信号铺设错误" checked={opForm.mtr2.includes('信号铺设错误')} onChange={(e) => {
                  const values = [...opForm.mtr2];
                  if (e.target.checked) {
                    values.push(e.target.value);
                  } else {
                    values.splice(values.indexOf(e.target.value), 1);
                  }
                  setOpForm({ ...opForm, mtr2: values });
                }} /> 信号铺设错误</label>
                <label><input type="checkbox" value="折返线未使用方向轨道而是普通轨道" checked={opForm.mtr2.includes('折返线未使用方向轨道而是普通轨道')} onChange={(e) => {
                  const values = [...opForm.mtr2];
                  if (e.target.checked) {
                    values.push(e.target.value);
                  } else {
                    values.splice(values.indexOf(e.target.value), 1);
                  }
                  setOpForm({ ...opForm, mtr2: values });
                }} /> 折返线未使用方向轨道而是普通轨道</label>
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3>MTR考察(5分)</h3>
            <div className="question-item">
              <label>MTR中一般来说，地铁城区最高时速为____，最高加速度为____，车厂段最高时速为____，6B编组列车站台长度至少____格，4A编组列车站台长度至少____格。(答案用逗号分开)</label>
              <div className="mtr-input-group">
                <input
                  type="text"
                  placeholder="最高时速"
                  value={mtrAnswer.speed}
                  onChange={(e) => setMtrAnswer({ ...mtrAnswer, speed: e.target.value })}
                  required
                />
                <input
                  type="text"
                  placeholder="最高加速度"
                  value={mtrAnswer.acceleration}
                  onChange={(e) => setMtrAnswer({ ...mtrAnswer, acceleration: e.target.value })}
                  required
                />
                <input
                  type="text"
                  placeholder="车厂段最高时速"
                  value={mtrAnswer.depotSpeed}
                  onChange={(e) => setMtrAnswer({ ...mtrAnswer, depotSpeed: e.target.value })}
                  required
                />
                <input
                  type="text"
                  placeholder="6B编组站台长度"
                  value={mtrAnswer.platform6b}
                  onChange={(e) => setMtrAnswer({ ...mtrAnswer, platform6b: e.target.value })}
                  required
                />
                <input
                  type="text"
                  placeholder="4A编组站台长度"
                  value={mtrAnswer.platform4a}
                  onChange={(e) => setMtrAnswer({ ...mtrAnswer, platform4a: e.target.value })}
                  required
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3>MTR考察(5分)</h3>
            <div className="question-item">
              <label>说出三个此指示牌通常用于的位置</label>
              <img src={signImage} alt="指示牌" className="question-image" />
              <input
                type="text"
                placeholder="请输入三个位置"
                value={opForm.mtr3}
                onChange={(e) => setOpForm({ ...opForm, mtr3: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="form-section">
            <h3>MTR考察(5分)</h3>
            <div className="question-item">
              <label>说出图中轨道通常用于什么地方</label>
              <img src={trackImage} alt="轨道" className="question-image" />
              <input
                type="text"
                placeholder="请输入答案"
                value={opForm.mtr4}
                onChange={(e) => setOpForm({ ...opForm, mtr4: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="form-section">
            <h3>综合考察(10分)</h3>
            <div className="question-item">
              <label>请详细说明一种曲线道路的建设方法</label>
              <textarea
                placeholder="请详细描述"
                value={opForm.curveMethod}
                onChange={(e) => setOpForm({ ...opForm, curveMethod: e.target.value })}
                rows={4}
                required
              />
            </div>
          </div>

          <div className="form-section">
            <h3>特长考察(10分)</h3>
            <div className="question-item">
              <label>完整城市，仿真机场&高铁站，追加包&模组，旅游景点建设，完备模板制作(隧道，桥梁，公路，接触网)，机械动力铁路，其中会一项5分，会两项及以上10分（需私信管理或群主验证）</label>
              <input
                type="text"
                placeholder="请说明你的特长"
                value={opForm.specialSkill}
                onChange={(e) => setOpForm({ ...opForm, specialSkill: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="form-section">
            <h3>18 建筑考察(30分)</h3>
            <div className="question-item">
              <label>如果你认为照片可以显示出你的水平，那么请上传自身完成的建筑作品，至少3张（与19题二选一作答）</label>
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleBuildingImagesChange}
              />
              <p className="form-note">图片要求：最少3张</p>
            </div>
          </div>

          <div className="form-section">
            <h3>19 建筑考察(30分)</h3>
            <div className="question-item">
              <label>如果你认为照片不能显示出你的水平，那么请在审核服内进行建造，建造完成后上传你在审核服内建造的位置（X Y Z）（与18题二选一作答）</label>
              <input
                type="text"
                placeholder="请输入"
                value={opForm.buildPosition}
                onChange={(e) => setOpForm({ ...opForm, buildPosition: e.target.value })}
              />
            </div>
          </div>

          <div className="form-section">
            <h3>20 态度考察</h3>
            <div className="question-item">
              <label>是否保证不炸服，不破坏，不辱骂其他玩家，且以上内容均为自身作答</label>
              <select
                value={opForm.guarantee}
                onChange={(e) => setOpForm({ ...opForm, guarantee: e.target.value })}
                required
                className="form-select"
              >
                <option value="">请选择</option>
                <option value="yes">是</option>
                <option value="no">否</option>
              </select>
            </div>
          </div>

          <div className="form-section">
            <h3>21 建筑调查</h3>
            <div className="question-item">
              <label>你在其他服务器进行过建设吗？如有，请说出服务器名称；如无，请填无</label>
              <input
                type="text"
                placeholder="请输入"
                value={opForm.previousServer}
                onChange={(e) => setOpForm({ ...opForm, previousServer: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="form-section">
            <h3>22 背景调查</h3>
            <div className="question-item">
              <label>你有进过其他服务器的黑名单吗？如有，请说明服务器名称、封禁原因；如无，请填无。务必诚实回答</label>
              <input
                type="text"
                placeholder="请输入"
                value={opForm.blacklistHistory}
                onChange={(e) => setOpForm({ ...opForm, blacklistHistory: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="form-section">
            <h3>23 自我介绍</h3>
            <div className="question-item">
              <label>有什么想说的在这里说</label>
              <textarea
                placeholder="请介绍一下自己"
                value={opForm.selfIntro}
                onChange={(e) => setOpForm({ ...opForm, selfIntro: e.target.value })}
                rows={4}
              />
            </div>
          </div>

          <div className="form-section">
            <h3>24 三连截图</h3>
            <div className="question-item">
              <label>请上传您的B站一键三连截图（B站名：龙腾铁路服务器）</label>
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleFileChange}
                required
              />
              <p className="form-note">图片要求：最多6张</p>
            </div>
          </div>

          <button type="submit" className="btn-primary">提交申请</button>
        </form>
      )}

      {activeTab === 'history' && (
        <div className="applications-history">
          <h2>我的申请记录</h2>
          {applications.length === 0 ? (
            <p className="no-applications">暂无申请记录</p>
          ) : (
            <div className="applications-list">
              {applications.map((app) => (
                <div key={app._id} className="application-card">
                  <div className="app-header">
                    <h3>{app.type === 'whitelist' ? '白名单申请' : 'OP申请'}</h3>
                    <span className={`status-badge ${getStatusClass(app.status)}`}>
                      {getStatusText(app.status)}
                    </span>
                  </div>
                  <div className="app-info">
                    <p><strong>申请时间:</strong> {formatDate(app.createdAt)}</p>
                    <p><strong>游戏ID:</strong> {app.gameId}</p>
                  </div>
                  {app.reviewComment && (
                    <div className="app-comment">
                      <p><strong>审核意见:</strong> {app.reviewComment}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Apply;